import {
    MarketingCarouselColorTheme,
    MarketingCarouselFallbackData,
} from '@servicetitan/onboarding-ui/contentful';

export const marketingCarouselFallbackData: MarketingCarouselFallbackData = {
    carouselSettings: {
        colorTheme: MarketingCarouselColorTheme.Light,
        backgroundImageUrl:
            'https://static.servicetitan.com/acm/auth/sign-in-carousel-background.png',
    },
    carouselData: [
        {
            headline: 'Meet TitanAdvisor',
            ctaLink: 'https://www.servicetitan.com/blog/titanadvisor-debut',
            ctaLabel: 'Learn More',
            imageUrl:
                'https://images.ctfassets.net/mb2ty0185mk8/1lkItezutEJnlMZUMQtoaH/d0d8b4d5e687b4071ebfca5cbf42ea9f/rocket.png',
            description:
                'Propel your business forward with personalized recommendations that help you get the most out of ServiceTitan.',
        },
    ],
};
